// ========== RYZO MINI PANEL (AliExpress-style) ==========

(function () {
  const ROOT_SELECTOR = '.products-grid-container[data-ryzo-mini="true"]';

  // Небольшие переводы для кнопки
  const BTN_I18N = {
    ru: 'Похожие товары',
    en: 'Similar items',
    fr: 'Articles similaires',
    nl: 'Vergelijkbare items',
    de: 'Ähnliche Artikel'
  };

  function getLang() {
    const raw = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    const short = raw.split('-')[0];
    if (BTN_I18N[short]) return short;
    return 'en';
  }
  const LANG = getLang();
  const BTN_TEXT = BTN_I18N[LANG];

  // Немного CSS чисто для мини-панели
  function injectMiniStyles() {
    if (document.getElementById('clb-ryzo-mini-styles')) return;

    const style = document.createElement('style');
    style.id = 'clb-ryzo-mini-styles';
    style.textContent = `
  /* карточка, к которой пристёгиваем панель */
  .clb-ryzo-mini-panel-anchor {
    position: relative !important;
  }

  /* корень панели — сидит внутри карточки, по её ширине */
  .clb-ryzo-mini-panel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 21;
    pointer-events: none; /* кликаем только по внутреннему блоку */
  }

  .clb-ryzo-mini-inner {
    position: relative;
    pointer-events: auto;
    width: 100%;
    background: rgba(0, 0, 0, .8);
    color: #e5e7eb;
    border-radius: 0 0 10px 10px;
    padding: 6px 8px 8px;
    
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  /* две маленькие карточки в ряд */
  .clb-ryzo-mini-items {
    display: flex;
    gap: 6px;
  }

  .clb-ryzo-mini-item {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
    gap: 3px;
  }

  .clb-ryzo-mini-thumb {
    position: relative;
    width: 100%;
    padding-top: 60%;
    border-radius: 10px;
    overflow: hidden;
    background: #020617;
  }
  .clb-ryzo-mini-thumb img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  
  /* зелёная цена прямо на мини-картинке */
  .clb-ryzo-mini-price-badge {
    position: absolute;
    left: 2px;
    bottom: 3px;
    padding: 2px 6px;
    border-radius: 999px;
    background: #16a34a;
    color: #ecfdf5;
    font-size: 8px;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.7);
  }

  .clb-ryzo-mini-name {
    font-size: 11px;
    line-height: 1.25;
    max-height: 2.5em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #e5e7eb;
  }

  /* низ панели: кнопка по центру */
  .clb-ryzo-mini-bottom {
    margin-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .clb-ryzo-mini-btn {
    border: none;
    border-radius: 999px;
    padding: 5px 14px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    background: #16a34a;
    color: #ecfdf5;
    white-space: nowrap;
    box-shadow: 0 6px 18px rgba(22,163,74,0.6);
  }
  .clb-ryzo-mini-btn:hover {
    background: #22c55e;
  }

  /* крестик в правом нижнем углу панели */
  .clb-ryzo-mini-close {
    position: absolute;
    right: 8px;
    bottom: 6px;
    border: none;
    background: transparent;
    color: #9ca3af;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    padding: 2px;
  }
  .clb-ryzo-mini-close:hover {
    color: #f9fafb;
  }

  @media (max-width: 768px) {
    .clb-ryzo-mini-inner {
      border-radius: 0 0 10px 10px;
      padding: 6px 7px 8px;
    }
  }
  `;
    document.head.appendChild(style);
  }

  function shorten(text, max) {
    const t = (text || '').trim();
    if (t.length <= max) return t;
    return t.slice(0, max - 1) + '…';
  }

  // Текущее состояние мини-поиска
  let lastSourceKey = null;
  let lastCard = null;
  let lastImageUrl = null;

  function attachMiniLogic(root) {
    if (!root) return;
    injectMiniStyles();

    // Клик по карточке в блоке рекомендаций
    root.addEventListener(
      'click',
      (event) => {
        // 🔧 НОВОЕ: игнорируем клики внутри самой мини-панели,
        // чтобы не трогать её при переходе по похожим товарам
        if (event.target.closest('.clb-ryzo-mini-panel')) {
          return;
        }

        const link = event.target.closest('a[href*="/products/"]');
        if (!link || !root.contains(link)) return;

        // Ищем контейнер карточки (li или .card / .product-card)
        const card =
          link.closest('li') ||
          link.closest('.product-card') ||
          link.closest('.card');
        if (!card) return;

        // убираем старые панели только при выборе "основной" карточки
        document.querySelectorAll('.clb-ryzo-mini-panel').forEach((p) => p.remove());

        lastCard = card;

        // Берём картинку из карточки
        const img =
          card.querySelector('.media img') ||
          card.querySelector('img');
        const imageUrl = img ? img.currentSrc || img.src : null;
        if (!imageUrl) return;

        lastImageUrl = imageUrl;

        // Гарантируем, что карточка может держать абсолютную панель
        card.classList.add('clb-ryzo-mini-panel-anchor');

        const sourceKey =
          'ryzo-mini-' +
          Date.now().toString(36) +
          Math.random().toString(36).slice(2);
        lastSourceKey = sourceKey;

        // Запускаем Ryzo в режиме preview.
        // ВАЖНО: НЕ делаем preventDefault — карточка спокойно открывается в новой вкладке/окне, если нужно.
        window.dispatchEvent(
          new CustomEvent('clb:ryzo:search', {
            detail: {
              imageUrl,
              mode: 'preview',
              source: { role: 'mini', key: sourceKey }
            }
          })
        );
      },
      true // capture, чтобы успеть до ухода со страницы
    );

    // Слушаем результат от основного ryzo-скрипта
    window.addEventListener('clb:ryzo:results', (e) => {
      if (!e || !e.detail) return;
      const { products, source } = e.detail;
      if (!source || source.role !== 'mini') return;
      if (source.key !== lastSourceKey) return; // старый запрос
      if (!lastCard) return;
      if (!Array.isArray(products) || products.length < 2) return;

      // просто пропускаем первый элемент (он почти всегда «сам» товар)
      const list = products.slice(1); // начинаем со второго

      if (!list.length) return;

      // берём вторую и третью карточки из ответа Ryzo
      renderMiniPanel(lastCard, list.slice(0, 2));
    });
  }

  function formatMiniPrice(item) {
    if (!item || typeof item !== 'object') return '';

    let raw = null;
    let currency = 'EUR';
    let currencyFound = false;

    function scan(obj) {
      if (!obj || typeof obj !== 'object') return;

      for (const [key, val] of Object.entries(obj)) {
        if (raw === null && /price/i.test(key) && val !== null && val !== undefined && val !== '') {
          raw = val;
        }

        if (
          !currencyFound &&
          /(curr|currency)/i.test(key) &&
          typeof val === 'string' &&
          val.trim()
        ) {
          currency = val.trim();
          currencyFound = true;
        }

        if (val && typeof val === 'object') {
          scan(val);
        }

        if (raw !== null && currencyFound) return;
      }
    }

    scan(item);

    if (raw === null || raw === undefined || raw === '') return '';

    let amount;

    if (typeof raw === 'number') {
      amount = raw;
    } else {
      const str = String(raw).trim();
      const digits = str.replace(/[^\d]/g, '');
      if (!digits) return str;

      if (digits.length <= 2) {
        amount = Number(digits);
      } else {
        amount = Number(digits) / 100;
      }
    }

    if (isNaN(amount)) return String(raw);

    const lang = document.documentElement.getAttribute('lang') || 'en-US';
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency
      }).format(amount);
    } catch (e) {
      return amount + ' ' + currency;
    }
  }

  function renderMiniPanel(card, products) {
    if (!card) return;

    // убираем старую панель на этой карточке, если была
    const existing = card.querySelector('.clb-ryzo-mini-panel');
    if (existing) existing.remove();

    const panel = document.createElement('div');
    panel.className = 'clb-ryzo-mini-panel';

    const itemsHtml = (products || [])
      .filter(Boolean)
      .map((p) => {
        const imgUrl = p.imageurl || p.image || '';
        const title = p.title || '';

        const priceText = formatMiniPrice(p);

        const priceHtml = priceText
          ? `<div class="clb-ryzo-mini-price-badge">${priceText}</div>`
          : '';

        return `
        <a class="clb-ryzo-mini-item" href="${p.url || '#'}" target="_blank" rel="noopener">
          <div class="clb-ryzo-mini-thumb">
            ${imgUrl ? `<img src="${imgUrl}" alt="${shorten(title, 60)}">` : ''}
            ${priceHtml}
          </div>
          <div class="clb-ryzo-mini-name">${shorten(title, 40)}</div>
        </a>
      `;
      })
      .join('');

    panel.innerHTML = `
    <div class="clb-ryzo-mini-inner">
      <button type="button" class="clb-ryzo-mini-close">×</button>
      <div class="clb-ryzo-mini-items">
        ${itemsHtml}
      </div>
      <div class="clb-ryzo-mini-bottom">
        <button type="button" class="clb-ryzo-mini-btn">${BTN_TEXT}</button>
      </div>
    </div>
  `;

    // крестик
    panel.querySelector('.clb-ryzo-mini-close').addEventListener('click', () => {
      panel.remove();
    });

    // кнопка "Similar items" → открыть большую Ryzo-модалку
    panel.querySelector('.clb-ryzo-mini-btn').addEventListener('click', () => {
      window.dispatchEvent(new Event('clb:ryzo:openModal'));
    });

    card.appendChild(panel);
  }

  // Ждём, пока блок рекомендаций появится на странице
  function waitForRoot() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) {
      setTimeout(waitForRoot, 400);
      return;
    }
    attachMiniLogic(root);
  }

  waitForRoot();
})();
